import {OrderItemProduct} from 'Query/Order.type';
import {formatPrice} from 'Util/Price';

/** @namespace Steinkrueger/Util/ErpPrice/getErpPriceValue */
export const getErpPriceValue = (erpPrice: string) => erpPrice !== formatPrice(0);

/** @namespace Steinkrueger/Util/ErpPrice/getProductFromOrderWithSelectedOptions */
export const getProductFromOrderWithSelectedOptions = (
    allProducts: OrderItemProduct[],
    requiredProductSku: string,
    selectedOptionsString: string,
): OrderItemProduct | undefined => allProducts.find(({ product_sku, selected_options }) => {
    const selectedOptionsJson = selected_options ? JSON.stringify(selected_options) : '';

    return product_sku === requiredProductSku && selectedOptionsString === selectedOptionsJson;
});
